export const errorClass = "text-red-500 text-sm italic";

export const drugFrequencyOptions = [
  { value: "QD", label: "Every Day" },
  { value: "QOD", label: "Every Other Day" },
  { value: "Q1H", label: "Every Hour" },
  { value: "Q2H", label: "Every 2 Hours" },
  { value: "Q3H", label: "Every 3 Hours" },
  { value: "Q4H", label: "Every 4 Hours" },
  { value: "Q6H", label: "Every 6 Hours" },
  { value: "Q8H", label: "Every 8 Hours" },
  { value: "BID", label: "Two Times Daily" },
  { value: "TID", label: "Three Times Daily" },
  { value: "QID", label: "Four Times Daily" },
  { value: "AM", label: "Every AM" },
  { value: "PM", label: "Every PM" },
  { value: "BED", label: "At Bedtime" },
  { value: "WK", label: "Weekly" },
  { value: "MO", label: "Monthly" },
  { value: "PRN", label: "As Needed" },
  { value: "OTHER", label: "Other" },
];

export const stateOptions = [
  {
    label: "Alabama",
    value: "Alabama",
    abbreviation: "AL",
  },
  {
    label: "Alaska",
    value: "Alaska",
    abbreviation: "AK",
  },
  {
    label: "Arizona",
    value: "Arizona",
    abbreviation: "AZ",
  },
  {
    label: "Arkansas",
    value: "Arkansas",
    abbreviation: "AR",
  },
  {
    label: "California",
    value: "California",
    abbreviation: "CA",
  },
  {
    label: "Colorado",
    value: "Colorado",
    abbreviation: "CO",
  },
  {
    label: "Connecticut",
    value: "Connecticut",
    abbreviation: "CT",
  },
  {
    label: "Delaware",
    value: "Delaware",
    abbreviation: "DE",
  },
  {
    label: "District Of Columbia",
    value: "District Of Columbia",
    abbreviation: "DC",
  },
  {
    label: "Florida",
    value: "Florida",
    abbreviation: "FL",
  },
  {
    label: "Georgia",
    value: "Georgia",
    abbreviation: "GA",
  },
  {
    label: "Hawaii",
    value: "Hawaii",
    abbreviation: "HI",
  },
  {
    label: "Idaho",
    value: "Idaho",
    abbreviation: "ID",
  },
  {
    label: "Illinois",
    value: "Illinois",
    abbreviation: "IL",
  },
  {
    label: "Indiana",
    value: "Indiana",
    abbreviation: "IN",
  },
  {
    label: "Iowa",
    value: "Iowa",
    abbreviation: "IA",
  },
  {
    label: "Kansas",
    value: "Kansas",
    abbreviation: "KS",
  },
  {
    label: "Kentucky",
    value: "Kentucky",
    abbreviation: "KY",
  },
  {
    label: "Louisiana",
    value: "Louisiana",
    abbreviation: "LA",
  },
  {
    label: "Maine",
    value: "Maine",
    abbreviation: "ME",
  },
  {
    label: "Maryland",
    value: "Maryland",
    abbreviation: "MD",
  },
  {
    label: "Massachusetts",
    value: "Massachusetts",
    abbreviation: "MA",
  },
  {
    label: "Michigan",
    value: "Michigan",
    abbreviation: "MI",
  },
  {
    label: "Minnesota",
    value: "Minnesota",
    abbreviation: "MN",
  },
  {
    label: "Mississippi",
    value: "Mississippi",
    abbreviation: "MS",
  },
  {
    label: "Missouri",
    value: "Missouri",
    abbreviation: "MO",
  },
  {
    label: "Montana",
    value: "Montana",
    abbreviation: "MT",
  },
  {
    label: "Nebraska",
    value: "Nebraska",
    abbreviation: "NE",
  },
  {
    label: "Nevada",
    value: "Nevada",
    abbreviation: "NV",
  },
  {
    label: "New Hampshire",
    value: "New Hampshire",
    abbreviation: "NH",
  },
  {
    label: "New Jersey",
    value: "New Jersey",
    abbreviation: "NJ",
  },
  {
    label: "New Mexico",
    value: "New Mexico",
    abbreviation: "NM",
  },
  {
    label: "New York",
    value: "New York",
    abbreviation: "NY",
  },
  {
    label: "North Carolina",
    value: "North Carolina",
    abbreviation: "NC",
  },
  {
    label: "North Dakota",
    value: "North Dakota",
    abbreviation: "ND",
  },
  {
    label: "Ohio",
    value: "Ohio",
    abbreviation: "OH",
  },
  {
    label: "Oklahoma",
    value: "Oklahoma",
    abbreviation: "OK",
  },
  {
    label: "Oregon",
    value: "Oregon",
    abbreviation: "OR",
  },
  {
    label: "Pennsylvania",
    value: "Pennsylvania",
    abbreviation: "PA",
  },
  {
    label: "Rhode Island",
    value: "Rhode Island",
    abbreviation: "RI",
  },
  {
    label: "South Carolina",
    value: "South Carolina",
    abbreviation: "SC",
  },
  {
    label: "South Dakota",
    value: "South Dakota",
    abbreviation: "SD",
  },
  {
    label: "Tennessee",
    value: "Tennessee",
    abbreviation: "TN",
  },
  {
    label: "Texas",
    value: "Texas",
    abbreviation: "TX",
  },
  {
    label: "Utah",
    value: "Utah",
    abbreviation: "UT",
  },
  {
    label: "Vermont",
    value: "Vermont",
    abbreviation: "VT",
  },
  {
    label: "Virgin Islands",
    value: "Virgin Islands",
    abbreviation: "VI",
  },
  {
    label: "Virginia",
    value: "Virginia",
    abbreviation: "VA",
  },
  {
    label: "Washington",
    value: "Washington",
    abbreviation: "WA",
  },
  {
    label: "West Virginia",
    value: "West Virginia",
    abbreviation: "WV",
  },
  {
    label: "Wisconsin",
    value: "Wisconsin",
    abbreviation: "WI",
  },
  {
    label: "Wyoming",
    value: "Wyoming",
    abbreviation: "WY",
  },
];

export const languages = [
  {
    value: "aa",
    label: "Afar",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ab",
    label: "Abkhaz",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ae",
    label: "Avestan",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "af",
    label: "Afrikaans",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ak",
    label: "Akan",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "am",
    label: "Amharic",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "an",
    label: "Aragonese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ar",
    label: "Arabic",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "as",
    label: "Assamese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "av",
    label: "Avaric",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ay",
    label: "Aymara",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "az",
    label: "Azerbaijani",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ba",
    label: "Bashkir",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "be",
    label: "Belarusian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "bg",
    label: "Bulgarian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "bh",
    label: "Bihari",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "bi",
    label: "Bislama",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "bm",
    label: "Bambara",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "bn",
    label: "Bengali",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "bo",
    label: "Tibetan Standard",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "br",
    label: "Breton",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "bs",
    label: "Bosnian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ca",
    label: "Catalan",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ce",
    label: "Chechen",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ch",
    label: "Chamorro",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "co",
    label: "Corsican",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "cr",
    label: "Cree",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "cs",
    label: "Czech",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "cu",
    label: "Old Church Slavonic",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "cv",
    label: "Chuvash",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "cy",
    label: "Welsh",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "da",
    label: "Danish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "de",
    label: "German",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "dv",
    label: "Divehi",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "dz",
    label: "Dzongkha",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ee",
    label: "Ewe",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "el",
    label: "Greek",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "en",
    label: "English",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "eo",
    label: "Esperanto",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "es",
    label: "Spanish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "et",
    label: "Estonian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "eu",
    label: "Basque",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "fa",
    label: "Persian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ff",
    label: "Fula",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "fi",
    label: "Finnish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "fj",
    label: "Fijian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "fo",
    label: "Faroese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "fr",
    label: "French",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "fy",
    label: "Western Frisian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ga",
    label: "Irish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "gd",
    label: "Scottish Gaelic",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "gl",
    label: "Galician",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "gn",
    label: "Guaraní",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "gu",
    label: "Gujarati",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "gv",
    label: "Manx",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ha",
    label: "Hausa",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "he",
    label: "Hebrew",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "hi",
    label: "Hindi",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ho",
    label: "Hiri Motu",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "hr",
    label: "Croatian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ht",
    label: "Haitian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "hu",
    label: "Hungarian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "hy",
    label: "Armenian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "hz",
    label: "Herero",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ia",
    label: "Interlingua",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "id",
    label: "Indonesian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ie",
    label: "Interlingue",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ig",
    label: "Igbo",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ii",
    label: "Nuosu",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ik",
    label: "Inupiaq",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "io",
    label: "Ido",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "is",
    label: "Icelandic",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "it",
    label: "Italian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "iu",
    label: "Inuktitut",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ja",
    label: "Japanese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "jv",
    label: "Javanese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ka",
    label: "Georgian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "kg",
    label: "Kongo",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ki",
    label: "Kikuyu",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "kj",
    label: "Kwanyama",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "kk",
    label: "Kazakh",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "kl",
    label: "Kalaallisut",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "km",
    label: "Khmer",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "kn",
    label: "Kannada",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ko",
    label: "Korean",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "kr",
    label: "Kanuri",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ks",
    label: "Kashmiri",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ku",
    label: "Kurdish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "kv",
    label: "Komi",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "kw",
    label: "Cornish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ky",
    label: "Kyrgyz",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "la",
    label: "Latin",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "lb",
    label: "Luxembourgish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "lg",
    label: "Ganda",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "li",
    label: "Limburgish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ln",
    label: "Lingala",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "lo",
    label: "Lao",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "lt",
    label: "Lithuanian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "lu",
    label: "Luba-Katanga",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "lv",
    label: "Latvian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "mg",
    label: "Malagasy",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "mh",
    label: "Marshallese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "mi",
    label: "Māori",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "mk",
    label: "Macedonian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ml",
    label: "Malayalam",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "mn",
    label: "Mongolian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "mr",
    label: "Marathi",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ms",
    label: "Malay",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "mt",
    label: "Maltese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "my",
    label: "Burmese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "na",
    label: "Nauru",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "nb",
    label: "Norwegian Bokmål",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "nd",
    label: "Northern Ndebele",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ne",
    label: "Nepali",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ng",
    label: "Ndonga",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "nl",
    label: "Dutch",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "nn",
    label: "Norwegian Nynorsk",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "no",
    label: "Norwegian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "nr",
    label: "Southern Ndebele",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "nv",
    label: "Navajo",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ny",
    label: "Chichewa",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "oc",
    label: "Occitan",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "oj",
    label: "Ojibwe",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "om",
    label: "Oromo",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "or",
    label: "Oriya",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "os",
    label: "Ossetian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "pa",
    label: "Panjabi",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "pi",
    label: "Pāli",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "pl",
    label: "Polish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ps",
    label: "Pashto",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "pt",
    label: "Portuguese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "qu",
    label: "Quechua",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "rm",
    label: "Romansh",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "rn",
    label: "Kirundi",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ro",
    label: "Romanian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ru",
    label: "Russian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "rw",
    label: "Kinyarwanda",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sa",
    label: "Sanskrit",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sc",
    label: "Sardinian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sd",
    label: "Sindhi",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "se",
    label: "Northern Sami",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sg",
    label: "Sango",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "si",
    label: "Sinhala",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sk",
    label: "Slovak",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sl",
    label: "Slovene",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sm",
    label: "Samoan",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sn",
    label: "Shona",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "so",
    label: "Somali",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sq",
    label: "Albanian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sr",
    label: "Serbian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ss",
    label: "Swati",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "st",
    label: "Southern Sotho",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "su",
    label: "Sundanese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sv",
    label: "Swedish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "sw",
    label: "Swahili",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ta",
    label: "Tamil",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "te",
    label: "Telugu",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "tg",
    label: "Tajik",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "th",
    label: "Thai",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ti",
    label: "Tigrinya",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "tk",
    label: "Turkmen",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "tl",
    label: "Tagalog",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "tn",
    label: "Tswana",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "to",
    label: "Tonga",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "tr",
    label: "Turkish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ts",
    label: "Tsonga",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "tt",
    label: "Tatar",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "tw",
    label: "Twi",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ty",
    label: "Tahitian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ug",
    label: "Uyghur",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "uk",
    label: "Ukrainian",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ur",
    label: "Urdu",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "uz",
    label: "Uzbek",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "ve",
    label: "Venda",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "vi",
    label: "Vietnamese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "vo",
    label: "Volapük",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "wa",
    label: "Walloon",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "wo",
    label: "Wolof",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "xh",
    label: "Xhosa",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "yi",
    label: "Yiddish",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "yo",
    label: "Yoruba",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "za",
    label: "Zhuang",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "zh",
    label: "Chinese",
    system: "http://www.iso.org/iso-639-1",
  },
  {
    value: "zu",
    label: "Zulu",
    system: "http://www.iso.org/iso-639-1",
  },
];
